import type { JSX } from 'solid-js';
import { t } from '../i18n';
import { Select } from './Select';

// Session-timeline toolbar (docs/idea/dashboard.md §Audit timeline: "Filter by
// tool, by outcome"). Client-side by design — the SSE stream already delivered
// every row (backfill → tail), so filtering is a view concern, never a refetch.
// Tool options are derived from the loaded events; outcomes are the row enum.
//
// Each filter is a standalone `label[for]` over the themed Select's trigger, not a
// wrapping label: the trigger is a button, and the open listbox names itself by the
// label's own `${id}-label`, so both ids below are load-bearing.

const OUTCOMES = ['', 'success', 'failure', 'skipped'] as const;

export function AuditTimelineFilters(props: {
  tools: readonly string[];
  tool: string;
  outcome: string;
  onTool: (v: string) => void;
  onOutcome: (v: string) => void;
}): JSX.Element {
  return (
    <div class="filter-row audit-timeline__filters">
      <div class="repo-audit__field">
        <label
          class="repo-audit__field-label"
          for="audit-timeline-tool"
          id="audit-timeline-tool-label"
        >
          {t('audit.filter_tool')}
        </label>
        <Select
          a11y={{ id: 'audit-timeline-tool' }}
          label={t('audit.filter_tool')}
          value={props.tool}
          options={[
            { value: '', label: t('audit_session.filter_all_tools') },
            ...props.tools.map((v) => ({ value: v, label: v })),
          ]}
          onChange={props.onTool}
        />
      </div>
      <div class="repo-audit__field">
        <label
          class="repo-audit__field-label"
          for="audit-timeline-outcome"
          id="audit-timeline-outcome-label"
        >
          {t('audit.filter_outcome')}
        </label>
        <Select
          a11y={{ id: 'audit-timeline-outcome' }}
          label={t('audit.filter_outcome')}
          value={props.outcome}
          options={OUTCOMES.map((v) => ({
            value: v,
            label: t(v === '' ? 'audit_session.filter_all_outcomes' : `audit_session.outcome_${v}`),
          }))}
          onChange={props.onOutcome}
        />
      </div>
    </div>
  );
}
